// extracted by mini-css-extract-plugin
export default {"container":"_6W2y20GUhcip7wEc8dQ6px","heading":"_6yJCKJvvVzbqdw4EfUzEAu","buttonContainer":"_2y1VtV3bgtdiENBfWNjGLx","extraAction":"_2YOkSVNJ8kI74ZbeDB9lx7"};